import React from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import PropTypes from 'prop-types'

import CreateRentalAddOnForm from './Form'

CreateRentalAddOnModal.propTypes = {
  close: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onSuccess: PropTypes.func,
  rentalId: PropTypes.string.isRequired
}

export default function CreateRentalAddOnModal({
  close,
  isOpen,
  onSuccess,
  rentalId,
  occupancyDate
}: {
  close: () => void
  isOpen: boolean
  onSuccess?: () => void
  rentalId: string
  occupancyDate: string
}) {
  return (
    <>
      <Modal toggle={close} isOpen={isOpen}>
        <ModalHeader toggle={close}>Create a Rental Add-On</ModalHeader>
        <ModalBody>
          <CreateRentalAddOnForm
            onSubmit={close}
            onSuccess={onSuccess}
            rentalId={rentalId}
            occupancyDate={occupancyDate}
          />
        </ModalBody>
      </Modal>
    </>
  )
}
